/**
 * IMPORTS
 */

import { create } from "zustand";
import { persist } from "zustand/middleware";

// typings
import { IRoles, IUserAuthState } from "@/store-zustand/user-auth/index.d";

// common / const / key-storage
import { ACCESS_TOKEN_KEY } from "@/common/const/key-storage";

export const useStoreZustandUserAuth = create<IUserAuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      isLoading: false,
      user: null,
      token: null,
      role: null,
      features: [],

      setIsAuthenticated: (isAuthenticated) => set({ isAuthenticated }),
      setIsLoading: (isLoading) => set({ isLoading }),
      setToken: (token) => set({ token }),
      setRole: (role: IRoles) => set({ role }),
      setFeatures: (features) => set({ features }),
      setUser: (user) => set({ user }),

      logout: () => {
        set({
          isAuthenticated: false,
          isLoading: false,
          user: null,
          token: null,
          role: null,
          features: [],
        });

        localStorage.removeItem("@zustand-user-auth");
        localStorage.removeItem(ACCESS_TOKEN_KEY);
      },

      getUserIsAuthenticated() {
        const token = localStorage.getItem(ACCESS_TOKEN_KEY);
        if (token !== null) {
          set({ isAuthenticated: true });
          return true;
        }
        set({ isAuthenticated: false });
        return false;
      },
    }),
    {
      name: "@zustand-user-auth",
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
        token: state.token,
        user: state.user,
        role: state.role,
        features: state.features,
      }),
    }
  )
);
